import { Icon } from 'react-native-paper';

export const HeaderBackImage = ({ tintColor }: { tintColor: string }) => (
  <Icon source="arrow-left" color={tintColor} size={24} />
);
